var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-page",class:{
    'chat-page--dark': _vm.isDarkMode,
    'chat-page--light': !_vm.isDarkMode
  }},[_c('ChatSidebar',{attrs:{"open":_vm.sidebarOpen},on:{"toggle":function($event){_vm.sidebarOpen = !_vm.sidebarOpen},"close":function($event){_vm.sidebarOpen = false}}}),_c('ChatArea',{attrs:{"sidebar-open":_vm.sidebarOpen},on:{"toggle-sidebar":function($event){_vm.sidebarOpen = !_vm.sidebarOpen}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }